<i *ngIf="this.uData.userStat != null" [mdbTooltip]="this.getUserAgentStr(this.uData.userAgent)" [style]="this.uData.userStat.connectionState  =='Excellent' ? 'color:green' :
this.uData.userStat.connectionState  == 'Fair' ? 'color:yellow' :
this.uData.userStat.connectionState  == 'Poor' ? 'color:red' :
'color:grey'" class="ri-wifi-fill"></i>